<template>
  <div v-if="userdata" class="c-user">
    <TheButton
      type="button"
      class="c-user__btn"
      @click.native="showMenu = !showMenu">
      {{ userdata.name.givenName }}<i class="app-icon-profile_icon" />
    </TheButton>
    <div v-if="showMenu"
      v-click-outside="dismissMenu"
      class="c-user__menu">
      <h3 class="c-user__menu-heading">
        {{ userdata.raw.name.givenName }} {{ userdata.raw.name.familyName }}
      </h3>
      <MenuLangSwitch />
      <div class="c-user__menu-button-wrapper">
        <TheButton class="c-user__menu-button" @click.native="logout">
          {{ $t('USER_LOGOUT') }}
        </TheButton>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import TheButton from '@forlagshuset/v-button'
import MenuLangSwitch from '@/components/MenuLangSwitch'

export default {
  components: {
    TheButton,
    MenuLangSwitch
  },

  setup (props, vm) {
    const showMenu = ref(false)
    const userdata = computed(() => vm.root.$store.state.user.user)
    const role = computed(() => vm.root.$store.getters['appConfig/isTeacher'] ? 'teacher' : 'student')

    function dismissMenu () {
      showMenu.value = false
    }

    const logout = () => {
      vm.root.$store.dispatch('user/logoutUser')
    }

    return {
      showMenu,
      userdata,
      dismissMenu,
      logout,
      role
    }
  }
}
</script>
